<div class="document-panel flex-col">
  <div class="detail-row">
    <cf2-date-field-top
      [ctrl]="getFc('documentDate')"
      [label]="labels.documentDate"
      [required]="required.documentDate"
      [disabled]="disabled.documentDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
    ></cf2-date-field-top>

    <ng-container *ngIf="showSectionCodeField">
      <ng-container *ngIf="categoryOptions$ | async as options">
        <cf2-select-field-top
          [ctrl]="getFc('documentSectionCode')"
          [label]="labels.documentSectionCode"
          [required]="required.documentSectionCode"
          [disabled]="disabled.documentSectionCode"
          [options]="options"
        ></cf2-select-field-top>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="['eo'].includes(this.globals.catchment)">
      <ng-container *ngIf="typeOptions$ | async as options">
        <cf2-select-field-top
          [ctrl]="getFc('documentTypeCode')"
          [label]="labels.documentTypeCode"
          [required]="required.documentTypeCode"
          [disabled]="disabled.documentTypeCode"
          [options]="options"
        ></cf2-select-field-top>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="numOfJobsOptions | async as options">
      <cf2-select-field-top
        [ctrl]="getFc('documentJobNum')"
        [label]="labels.documentJobNum"
        [required]="required.documentJobNum"
        [disabled]="disabled.documentJobNum"
        [options]="options"
      ></cf2-select-field-top>
    </ng-container>

    <!--<ng-container *ngIf="categoryCodeOptions$ | async as options">
      <cf2-select-field-top
        [ctrl]="getFc('documentCategoryCode')"
        [label]="labels.documentCategoryCode"
        [required]="required.documentCategoryCode"
        [disabled]="disabled.documentCategoryCode"
        [options]="options"
      ></cf2-select-field-top>
    </ng-container>

    <ng-container *ngIf="subcategoryCodeOptions$ | async as options">
      <cf2-select-field-top
        [ctrl]="getFc('documentSubCategoryCode')"
        [label]="labels.documentSubCategoryCode"
        [required]="required.documentSubCategoryCode"
        [disabled]="disabled.documentSubCategoryCode"
        [options]="options"
      ></cf2-select-field-top>
    </ng-container>-->
  </div>

  <div class="comments-row">
    <cf2-textarea-field-top
      [ctrl]="getFc('comment')"
      [fullWidth]="true"
      [label]="labels.comment"
      [required]="required.comment"
      [disabled]="false"
      [rows]="2"
    ></cf2-textarea-field-top>
  </div>

  <div class="file-uploader-row">
    <!-- for the upload box -->
    <ng-content></ng-content>
  </div>
</div>